import React from "react";
import MultiselectTableHeader from "./MultiselectTableHeader";
import MultiselectTableBody from "./MultiselectTableBody";
import "./styles/table.css";
import "./styles/multiselectTable.css";

const MultiselectTable = ({
  className,
  columns,
  idPropName,
  disabledItems,
  selectedItems,
  deletedItems,
  onSelect,
  onDeselect,
  sortColumn,
  onSort,
  data,
  disableAllSort,
  isPaginated,
  currPage,
  pageCount,
  getNextPage,
  searchString,
  showAdd,
  addCallback,
}) => {
  return (
    <table className={className}>
      <MultiselectTableHeader
        columns={columns}
        sortColumn={sortColumn}
        onSort={onSort}
        disableAllSort={disableAllSort}
      />
      <MultiselectTableBody
        columns={columns}
        data={data}
        idPropName={idPropName}
        disabledItems={disabledItems}
        selectedItems={selectedItems}
        deletedItems={deletedItems}
        onSelect={onSelect}
        onDeselect={onDeselect}
        isPaginated={isPaginated}
        currPage={currPage}
        pageCount={pageCount}
        getNextPage={getNextPage}
        searchString={searchString}
        showAdd={showAdd}
        addCallback={addCallback}
      />
    </table>
  );
};

export default MultiselectTable;
